import React from 'react'
import { PhoneNumberLink } from '../../components/PhoneNumberLink'
import { EmailThruChatWindow } from '../../components/EmailThruChatWindow'
import { Col, Row } from 'react-bootstrap'
import { SpecialtyCard } from '../../components/SpecialtyCard'

export default function Specialty() {
  return (
    <>
      <section className="py-4 text-center ">
        <h1 className="fst-italic">Specializing in all of your panel opening needs for over 35 years!</h1>
        <h5>CAGE CODE: 722G1</h5>
        <h1>
          <PhoneNumberLink /> <span>(toll free)</span>
        </h1>
      </section>

      <section className="pb-5">
        <Row>
          <Col md={4}>
            <SpecialtyCard
              icon="star"
              iconClassName="bg-success"
              title="Meeting your needs"
              description="Whether your a small company or aerospace giant, we are happy to provide custom solutions as well as our standard off the shelf products."
            />
          </Col>
          <Col md={4}>
            <SpecialtyCard
              icon="calendar"
              iconClassName="bg-primary"
              title="We maintain a large inventory"
              description="We have the largest stock inventory of any manufacturer. If you cannot find the die you are looking for elsewhere, it is probably in stock here."
            />
          </Col>
          <Col md={4}>
            <SpecialtyCard
              icon="comment-dots"
              iconClassName="bg-danger"
              title="Customer support 24/7"
              description={
                <>
                  Need quotations or services related to our product? Call us
                  <span className="mx-1">
                    <PhoneNumberLink />
                  </span>
                  (toll free) or email
                  <span className="mx-1">
                    <EmailThruChatWindow />
                  </span>
                  and we will get back to you as soon as possible.
                </>
              }
            />
          </Col>
        </Row>
      </section>
    </>
  )
}
